export default __webpack_public_path__ + "static/media/instagramWallBerlin.fbebe10f.png";